module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-19 at 4.37.26 PM.4c1731a3.jpeg";